(function(){
  'use strict';

  var GIFTS_VIDEO='https://cdn.shopify.com/videos/c/o/v/16154630e588458b9a75146119092794.mp4';
  var SHOPCAT_VIDEO='https://cdn.shopify.com/videos/c/o/v/8f59f0e0cf874640a54169483c06d592.mp4';

  function installVideo(selector,src,label,options){
    var slot=document.querySelector(selector);
    if(!slot) return;
    options=options||{};

    var video=slot.querySelector('video.js-home-placeholder-video');
    if(!video){
      slot.innerHTML='';
      slot.classList.add('js-home-video-slot');
      slot.setAttribute('aria-label',label);
      video=document.createElement('video');
      video.className='js-home-placeholder-video';
      video.autoplay=true;
      video.muted=true;
      video.loop=true;
      video.playsInline=true;
      video.setAttribute('muted','');
      video.setAttribute('playsinline','');
      video.setAttribute('preload','metadata');
      video.setAttribute('aria-label',label);
      slot.appendChild(video);
    }

    if(video.getAttribute('src')!==src) video.setAttribute('src',src);

    slot.style.setProperty('overflow','hidden','important');
    slot.style.setProperty('padding','0','important');
    slot.style.setProperty('border','0','important');
    slot.style.setProperty('background','#0b0312','important');

    if(options.ratio169){
      slot.classList.add('js-home-video-slot-169');
      slot.style.setProperty('aspect-ratio','16 / 9','important');
      slot.style.setProperty('height','auto','important');
      slot.style.setProperty('min-height','0','important');
      slot.style.setProperty('max-height','none','important');
      slot.style.setProperty('align-self','center','important');
      slot.style.setProperty('margin-top','auto','important');
      slot.style.setProperty('margin-bottom','auto','important');
    }

    video.style.setProperty('display','block','important');
    video.style.setProperty('width','100%','important');
    video.style.setProperty('height','100%','important');
    video.style.setProperty('object-fit',options.ratio169?'contain':'cover','important');
    video.style.setProperty('object-position','center center','important');
    video.style.setProperty('border-radius','inherit','important');

    var promise=video.play();
    if(promise&&typeof promise.catch==='function') promise.catch(function(){});
  }

  function apply(){
    if(!document.body.classList.contains('pageindex')&&!document.body.classList.contains('template-index')) return;
    installVideo('.js-gifts-square-placeholder',GIFTS_VIDEO,'JustSmoke gifts and bundles video',{ratio169:true});
    installVideo('.js-fresh-shopcat-placeholder',SHOPCAT_VIDEO,'JustSmoke shop by category video');
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',apply,{once:true}); else apply();
  window.addEventListener('load',apply,{once:true});
  document.addEventListener('shopify:section:load',function(){setTimeout(apply,0);});
  [100,400,1000,2200].forEach(function(ms){setTimeout(apply,ms);});
})();
